import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { isNullOrUndefined } from 'utils/Global';
import { VolumetricLayerKey } from './VolumetricLayerKey';
import { VolumetricWellLayers } from './VolumetricWellLayers';
import EVolumetricLayerDispense from './EVolumetricLayerDispense';
import EVolumetricLayerType from './EVolumetricLayerType';
import { WellIng, WellLayer, WellLayerIngredientDto } from 'components/Experiment/constants';

export class VolumetricWellLayer {
  key: VolumetricLayerKey;
  readonly Layers: VolumetricWellLayers;
  wellLayers = new Array<WellLayer>();
  docData: ExperimentDtoClient;
  wellLayerIngredientRows: WellLayerIngredientDto[];
  constructor(
    docData: ExperimentDtoClient,
    layers: VolumetricWellLayers,
    dispense: EVolumetricLayerDispense,
    type: EVolumetricLayerType,
    wellLayers: WellLayer[],
  ) {
    this.docData = docData as ExperimentDtoClient;
    this.key = new VolumetricLayerKey({
      dispense,
      type,
      layersIDs: wellLayers.map((wellLayer) => wellLayer.layerId),
    });
    this.Layers = layers;
    this.wellLayers = [...wellLayers];
  }
  get Key(): VolumetricLayerKey {
    return this.key;
  }
  public get WellRow(): WellIng {
    return this.Layers.WellRow;
  }
  public GetFirstWellLayerRow(): WellLayer {
    return this.wellLayers[0];
  }
  public get WellID(): number {
    return this.Layers.WellID;
  }
  public get Volume(): number {
    return this.wellLayers[0].volume;
  }
  public set Volume(value) {
    for (const wellLayer of this.wellLayers) {
      wellLayer.volume = value;
    }
  }
  public get WaterVolume() {
    return this.wellLayers[0].waterVolume;
  }
  public set WaterVolume(value) {
    for (const wellLayer of this.wellLayers) {
      wellLayer.waterVolume = value;
    }
  }
  public IsSourceWellIDNull(): boolean {
    return isNullOrUndefined(this.wellLayers[0].sourceWellId);
  }

  public set SourceWellID(value) {
    for (const wellLayer of this.wellLayers) {
      wellLayer.sourceWellId = value;
    }
  }
  public get SourceWellID() {
    return this.wellLayers[0].sourceWellId;
  }

  public set SourceWellRow(value) {
    for (const wellLayer of this.wellLayers) {
      wellLayer.sourceWellId = value.ID;
    }
  }
  public IsSourcePlateIDNull(): boolean {
    return this.IsSourceWellIDNull();
  }
  public SourcePlateID(): number {
    return this.SourceWellRow.PlateID;
  }
  public get SourcePlateRow() {
    return this.SourceWellRow.PlateRow;
  }
  public IsWaterSourceNull(): boolean {
    return isNullOrUndefined(this.wellLayers[0].waterSource);
  }
  public SetWaterSourceNull() {
    for (const wellLayer of this.wellLayers) {
      wellLayer.waterSource = null;
    }
  }
  public get WaterSource() {
    return this.wellLayers[0].waterSource;
  }
  public set WaterSource(value) {
    for (const wellLayer of this.wellLayers) {
      wellLayer.waterSource = value;
    }
  }

  public IsNull(columnName): boolean {
    return isNullOrUndefined(this.wellLayers[0]); // Here check for coloumnname of this either null
  }

  public GetIngredientRows(): WellLayerIngredientDto[] {
    if (this.wellLayerIngredientRows == null) {
      this.wellLayerIngredientRows = [];
      for (const wellLayerRow of this.wellLayers) {
        this.wellLayerIngredientRows = [
          ...this.wellLayerIngredientRows,
          ...wellLayerRow.wellLayerIngredientList,
        ];
      }
    }
    return this.wellLayerIngredientRows;
  }
  public static GetRobotLayer(docData, wellRow): VolumetricWellLayer {
    const layers: VolumetricWellLayers = VolumetricWellLayers.GetRobotLayers(
      docData,
      wellRow,
    );
    if (layers.IsSingleLayer()) {
      return layers.SingleLayer;
    }
    return null;
  }
  public static GetLayer(
    docData,
    wellRow: WellIng,
    key: VolumetricLayerKey,
  ): VolumetricWellLayer {
    return VolumetricWellLayers.GetWellLayers(docData, wellRow).GetLayer(key);
  }
}
